import failedIconSrc from '../../assets/icons/orderStatusIcons/failed.png'
import GenericIcon from './GenericIcon'

const FailedIcon = ({ className }) => {
  return <GenericIcon src={failedIconSrc} alt="Failed Icon" className={className} />
}

export default FailedIcon
